export interface VirtualBinaryFile {
  id: string;
  url?: string;
  /** Presigned URL with Content-Disposition: attachment — preferred for download buttons. */
  downloadUrl?: string;
  status: 'UPLOADING' | 'DONE' | 'ERROR';
  errorMessage?: string;
  progress: number;
  meta: {
    mimeType: string;
    size: number;
    name: string;
  };
}

export interface BaseFileUploaderProps {
  accept?: string;
  disabled?: boolean;
  required?: boolean;
  maxFileSize?: number;
  returnUrl?: boolean;
  graphqlClientId?: string;
  private?: boolean;
}

export interface FileUploaderProps extends BaseFileUploaderProps {
  clearable?: boolean;
}

export type FilesUploaderProps = BaseFileUploaderProps;

export const baseFileUploaderDefaults = {
  accept: '*',
  disabled: false,
  required: false,
  maxFileSize: 5 * 1024 * 1024, // 5MB
  returnUrl: false,
  graphqlClientId: 'default',
  // Default to private: uploaded files are user-supplied content (student
  // documents, attachments) that should require auth to read. Opt in to
  // public uploads explicitly via `:private="false"` for genuinely shared
  // assets.
  private: true,
} as const;

export const fileUploaderDefaults = {
  ...baseFileUploaderDefaults,
  clearable: true,
} as const;

export const filesUploaderDefaults = baseFileUploaderDefaults;

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return '0 B';
  }

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const size = bytes / Math.pow(k, i);
  const formattedSize = i === 0 ? size.toString() : size.toFixed(1);

  return `${formattedSize} ${sizes[i]}`;
};

export const parseAcceptToFileTypes = (accept: string): string[] => {
  if (!accept || accept === '*' || accept === '*/*') {
    return [];
  }

  return accept.split(',').map((type) => type.trim()).filter(Boolean);
};
